module.exports = __webpack_public_path__ + "static/media/synopsis-correlations-and-automated-charting-01@3x.f664d1c8.png";